import React, { useState } from "react";
import { usePopup } from "../Popup/PopupContext";
import PopupModel from "../Popup/PopupModel";
import config from "../../config";
import { formatPossessive } from "../../CommonFunctions";
import { CiLink } from "react-icons/ci";
import { FundraiserForAccount } from "../../Interfaces/AccountUsers";
import { PARTICIPANT } from "../../constants";
import { FundraiserInfo } from "../../Interfaces/FundraiserRole";

interface ShareButtonProps {
  participantID: string;
  participantName?: string;
  organizationName: string;
  style?: React.CSSProperties; // optional style prop
}
// TODO: DEPRECATED REMOVE ONCE new dashboard goes into effect
const ShareButton: React.FC<ShareButtonProps> = ({
  participantID,
  participantName,
  organizationName,
  style,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const { showPopup, hidePopup } = usePopup();

  const coppiedToClipBoardPopUp = new PopupModel(
    "Store Link Copied",
    <div>
      The store link was successfully copied to your clipboard. You can now
      right click and paste (or press CTRL-V) as a shortcut to paste it.
    </div>,
    [
      {
        label: "Okay",
        onClick: () => {
          hidePopup();
        },
      },
    ],
    "40vw",
  );

  React.useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    setIsMobile(/mobile/i.test(userAgent));
  }, []);

  const handleShare = async () => {
    const url = `${config.REACT_APP_SITE_URL}participant-shop/part-id/${participantID}`;

    const navigatorPreText = `Hey! This is ${participantName} and I’m raising money for ${organizationName}. We could really use your help and support with the fundraiser. Please check out my personalized store link.

Any donation or purchase, big or small, makes a huge difference! Thank you so much!
    `;

    if (isMobile && navigator.share) {
      try {
        const title = participantName
          ? `${formatPossessive(participantName)} Store`
          : "Support My Fundraiser!";
        await navigator.share({
          title: title,
          text: navigatorPreText,
          url: url,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      try {
        await navigator.clipboard.writeText(url);
        showPopup(
          coppiedToClipBoardPopUp.header,
          coppiedToClipBoardPopUp.body,
          coppiedToClipBoardPopUp.buttons,
          coppiedToClipBoardPopUp.width,
        );
      } catch (error) {
        console.error("Failed to copy text:", error);
      }
    }
  };

  const defaultStyle: React.CSSProperties = {
    backgroundColor: "#1c1c1c",
    color: "#ffffff",
    border: "none",
    borderRadius: "20px",
    padding: "0.5rem 1rem",
    fontSize: "1.8rem",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
  };
  return (
    <button
      style={style || defaultStyle} // apply custom or fallback style
      onClick={handleShare}
    >
      {isMobile ? (
        <>
          <CiLink size={24} /> Share Link
        </>
      ) : (
        <>
          <CiLink size={24} /> Copy Store Link
          <br />
        </>
      )}
    </button>
  );
};

interface ParticipantDashboardShareButtonProps {
  fundraiserName: string;
  participantName: string;
  fundraiserCode: string;
  buttonText: string;
  extraFunctionality?: () => void; // optional extra functionality on click
  style?: React.CSSProperties; // optional style prop
}
export const ParticipantDashboardShareButton: React.FC<
  ParticipantDashboardShareButtonProps
> = ({
  fundraiserName,
  participantName,
  fundraiserCode,
  buttonText,
  style,
  extraFunctionality,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const { showPopup, hidePopup } = usePopup();

  const coppiedToClipBoardPopUp = new PopupModel(
    "Store Link Copied",
    <div>
      The link was successfully copied to your clipboard. You can now right
      click and paste (or press CTRL-V) as a shortcut to paste it.
    </div>,
    [
      {
        label: "Okay",
        onClick: () => {
          hidePopup();
        },
      },
    ],
    "40vw",
  );

  React.useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    setIsMobile(/mobile/i.test(userAgent));
  }, []);

  const handleShare = async () => {
    extraFunctionality && extraFunctionality(); // execute extra functionality if provided
    const url = `${config.REACT_APP_SITE_URL}participant-shop/part-id/${fundraiserCode}`;

    const participantShareText = `Hey! This is ${participantName} and I’m raising money for ${fundraiserName}. We could really use your help and support with the fundraiser. Please check out my personalized store link.

    Any donation or purchase, big or small, makes a huge difference! Thank you so much!
    `;

    const title = `${formatPossessive(fundraiserName)} Store`;

    if (isMobile && navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: participantShareText,
          url: url,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      try {
        await navigator.clipboard.writeText(url);
        showPopup(
          coppiedToClipBoardPopUp.header,
          coppiedToClipBoardPopUp.body,
          coppiedToClipBoardPopUp.buttons,
          coppiedToClipBoardPopUp.width,
        );
      } catch (error) {
        console.error("Failed to copy text:", error);
      }
    }
  };

  const defaultStyle: React.CSSProperties = {
    backgroundColor: "#1c1c1c",
    color: "#ffffff",
    border: "none",
    borderRadius: "20px",
    padding: "0.5rem 1rem",
    fontSize: "1.8rem",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
  };
  return (
    <button
      style={style || defaultStyle} // apply custom or fallback style
      onClick={handleShare}
    >
      <CiLink size={24} /> {buttonText}
    </button>
  );
};

export default ShareButton;
